import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck } = FiIcons;

const scoringAreas = [
  'Keeping the student’s voice at the center',
  'Accuracy about rules',
  'Clear, usable guidance',
  'A calm, honest tone with safety habits'
];

function Scoring() {
  return (
    <section className="scoring-section">
      <div className="scoring-inner section-wrap">
        <div className="scoring-copy">
          <span className="eyebrow">A thoughtful debrief</span>
          <h2>What you’ll be scored on</h2>
          <p>Feedback is focused on practical ways to support the family in front of you.</p>
        </div>
        <div className="scoring-list">
          {scoringAreas.map((area) => (
            <div className="scoring-item" key={area}>
              <span className="check-icon"><SafeIcon icon={FiCheck} aria-hidden="true" /></span>
              <span>{area}</span>
            </div>
          ))}
          <div className="scoring-close">and ending with one clear next step.</div>
        </div>
      </div>
    </section>
  );
}

export default Scoring;
